import { Check } from "lucide-react";
import { price } from "@/lib/api";

export const TicketPicker = ({ tickets, value, onChange }) => (
  <div className="space-y-3" data-testid="ticket-picker">
    {tickets.map((t) => {
      const active = value === t.id;
      return (
        <button key={t.id} type="button" onClick={() => onChange(t.id)} data-testid={`ticket-option-${t.id}`}
          className={`flex w-full rounded-md items-start justify-between gap-3 border px-4 py-4 sm:gap-4 sm:px-6 sm:py-5 text-left transition-colors duration-200 ${
            active ? "border-[#C9A24B] bg-[#C9A24B]/15" : "border-white/15 bg-white/[0.04] hover:border-[#C9A24B]/60"}`}>
          <span>
            <span className="flex items-center gap-2 font-display text-lg text-white">
              {active && <Check className="h-4 w-4 text-[#D9B864]" />}{t.name}
            </span>
            <span className="mt-2 block text-sm leading-relaxed text-[#BDB3A5]">{t.description}</span>
          </span>
          <span className="shrink-0 text-right font-mono">
            <span className="block text-xl font-semibold text-[#D9B864] sm:text-2xl">{price(t.price)}</span>
            <span className="text-[11px] text-[#BDB3A5]">/person</span>
          </span>
        </button>
      );
    })}
  </div>
);
